import { Flex, Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { useAiPolicies } from "@/pages/GovernancePage/applications/policies/useAiPolicies"
import { getRuleOption } from "@/pages/GovernancePage/applications/policies/useAiPolicies.selector"

import styles from "./RuleCard.module.scss"

import type { PolicyRecord } from "@/pages/GovernancePage/applications/policies/getDemoData.types"

// One condition of a rule: its name, how it compares and the values it takes.
// A condition that compares nothing, as a guardrail that is detected, is its
// name alone
export const RuleCondition = ({
  rule
}: {
  rule: PolicyRecord["rules"][number]
}) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "governance.ai.form.rules"
  })
  const { ruleOptions } = useAiPolicies()
  const option = getRuleOption(ruleOptions, rule.id)

  return (
    <Flex gap={8} align="start" className={styles.wrapper}>
      <Flex gap={4} align="start">
        <Text className={styles.nowrap}>{t(rule.id)}</Text>
        {option?.scope && (
          <Text className={styles.nowrap} type="secondary">
            {t(`scopes.${option.scope}`)}
          </Text>
        )}
      </Flex>
      {rule.value.length > 0 && (
        <Flex wrap align="center" gap={6}>
          {rule.value.map((value, index) => (
            <Text key={index} className={styles.tag}>
              {option?.options?.find((item) => item.value === value)?.label ??
                value}
            </Text>
          ))}
        </Flex>
      )}
    </Flex>
  )
}
